module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-panel', {
    attrs: {
      "id": "admin-screen"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.loading
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "automation-filter-area "
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4"
  }, [_c('div', {
    staticClass: "title text-uppercase"
  }, [_c('h3', [_c('span', [_c('i', {
    staticClass: "icon-user"
  })]), _vm._v(" " + _vm._s(_vm.$t("admin.index.title")))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'contracts'),
      expression: "activeTab == 'contracts'"
    }],
    staticClass: "col-lg-8 col-md-8"
  }, [_c('span', {
    staticClass: "plus-icon pull-right",
    attrs: {
      "data-toggle": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.activeTab == 'invoices' ? _vm.new_template('invoice') : _vm.activeTab == 'contracts' ? _vm.new_template('contract') : ''
      }
    }
  }, [_c('div', {
    staticClass: "icon plus-icon"
  }, [_c('img', {
    staticClass: "plus-icon-new",
    attrs: {
      "src": "static/assets/images/plus_icon.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "calender_year pull-right"
  })])])]), _vm._v(" "), _c('div', {
    class: _vm.loading ? 'hide col-sm-12' : 'col-sm-12'
  }, [_c('div', {
    staticClass: "panel settings-page"
  }, [_c('div', {
    staticClass: "account-tabs"
  }, [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    class: _vm.activeTab == 'users' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('users')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("admin.index.users.title")))]), _vm._v(" "), _c('li', {
    class: _vm.activeTab == 'contracts' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('contracts')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("admin.index.contract_template.title")))]), _vm._v(" "), _c('li', {
    class: _vm.activeTab == 'configuration' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('configuration')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("admin.configuration.title")))]), _vm._v(" "), _c('li', {
    class: _vm.activeTab == 'tools' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('tools')
      }
    }
  }, [_vm._v("Tools")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'users'),
      expression: "activeTab == 'users'"
    }],
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "margin": "15px 5px 25px 5px",
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userSearch),
      expression: "userSearch"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "id, email, prénom, nom, téléphone"
    },
    domProps: {
      "value": (_vm.userSearch)
    },
    on: {
      "keyup": function($event) {
        _vm.search_user()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userSearch = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "table table-responsive",
    attrs: {
      "id": "users-table"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Id")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('admin.index.users.created')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('input.first_name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('input.last_name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('admin.index.users.email')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('admin.index.users.phone')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('admin.index.users.status')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('admin.index.users.subscription')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('admin.index.users.confirm')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('admin.index.users.trial_start')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('admin.index.users.trial_end')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('admin.index.users.last_login')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('admin.index.users.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(user) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(user.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.created_at.slice(0, -9)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.first_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.last_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.phone))]), _vm._v(" "), _c('td', {
      staticClass: "activate-user-switch",
      on: {
        "click": function($event) {
          _vm.change_status_user(user)
        }
      }
    }, [_c('switches', {
      attrs: {
        "theme": "bulma",
        "color": "blue",
        "type-bold": "false"
      },
      model: {
        value: (user.active),
        callback: function($$v) {
          _vm.$set(user, "active", $$v)
        },
        expression: "user.active"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "activate-user-switch",
      on: {
        "click": function($event) {
          _vm.pause_subscription_user(user)
        }
      }
    }, [_c('switches', {
      attrs: {
        "theme": "bulma",
        "color": "blue",
        "type-bold": "false",
        "disabled": _vm.disableSubscriptionBtn
      },
      model: {
        value: (user.pause_subscription),
        callback: function($$v) {
          _vm.$set(user, "pause_subscription", $$v)
        },
        expression: "user.pause_subscription"
      }
    })], 1), _vm._v(" "), _c('td', {
      on: {
        "click": function($event) {
          _vm.confirm_user(user)
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-primary btn-red btn-save waves-effect",
      attrs: {
        "disabled": user.confirmed == 1
      }
    }, [_vm._v(_vm._s(_vm.$t('admin.index.users.confirm')))])]), _vm._v(" "), _c('td', [(user.main_subscription) ? _c('span', [_vm._v(_vm._s(_vm.getStartDate(user.main_subscription.created_at)))]) : _vm._e()]), _vm._v(" "), _c('td', [(user.main_subscription) ? _c('span', [_vm._v(_vm._s(user.main_subscription.trial_ends_at ? _vm.getTrialDate(user.main_subscription.trial_ends_at) : ''))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.last_login))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "channel-change"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('div', {
      staticClass: "dropdown"
    }, [_c('button', {
      staticClass: "btn btn-primary dropdown-toggle",
      attrs: {
        "type": "button",
        "data-toggle": "dropdown"
      }
    }, [_c('i', {
      staticClass: "bulle"
    })]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu dropdown-menu-right"
    }, [(user.main_subscription) ? _c('a', {
      staticClass: "dropdown-item waves-effect waves-light waves-round",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openChangeTrialModal(user)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("admin.index.users.update_trial")))]) : _vm._e(), _vm._v(" "), (user.plan_id !== 4 && user.role_id !== 1 && !user.is_team_member) ? _c('a', {
      staticClass: "dropdown-item waves-effect waves-light waves-round",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.changePlan(user.id, 4)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('admin.index.users.change_plan_to_four')))]) : _vm._e(), _vm._v(" "), (user.plan_id === 1 && user.role_id !== 1 && !user.is_team_member) ? _c('a', {
      staticClass: "dropdown-item waves-effect waves-light waves-round",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.changePlan(user.id, 3)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('admin.index.users.change_plan_to_three')))]) : _vm._e(), _vm._v(" "), (user.plan_id === 4 && user.username && user.beds24ApiKey && user.role_id !== 1) ? _c('a', {
      staticClass: "dropdown-item waves-effect waves-light waves-round",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.changePlan(user.id, 3)
        }
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.$t('admin.index.users.change_plan_to_three')) + "\n                              ")]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "dropdown-item waves-effect waves-light waves-round",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.delete_user(user.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('admin.index.users.delete')))])])])])])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('nav', {
    attrs: {
      "aria-label": "Page navigation example"
    }
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "page-item",
    class: {
      'disabled': _vm.usersPage <= 1 && _vm.usersPage != 1
    }
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.search_user_prev()
      }
    }
  }, [_vm._v("Previous")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item",
    class: {
      'disabled': _vm.usersPage >= _vm.usersPages && _vm.usersPages != 1
    }
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.search_user_next()
      }
    }
  }, [_vm._v("Next")])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'contracts'),
      expression: "activeTab == 'contracts'"
    }],
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "table table-responsive",
    attrs: {
      "id": "users-table"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('admin.contract.create.thumbnail')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('admin.contract.create.name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('admin.index.users.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.contracts), function(contract) {
    return _c('tr', [_c('td', [_c('img', {
      staticClass: "template-thumbnail",
      attrs: {
        "src": "/static/assets/images/doc-icon.png"
      }
    })]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(contract.name))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "channel-change"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('div', {
      staticClass: "dropdown"
    }, [_c('button', {
      staticClass: "btn btn-primary dropdown-toggle",
      attrs: {
        "type": "button",
        "data-toggle": "dropdown"
      }
    }, [_c('i', {
      staticClass: "bulle"
    })]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu dropdown-menu-right"
    }, [_c('a', {
      staticClass: "dropdown-item waves-effect waves-light waves-round",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.edit(contract, 'contract')
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("button.edit")))]), _vm._v(" "), _c('a', {
      staticClass: "dropdown-item waves-effect waves-light waves-round",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.delete_tempalte(contract.id, 'contract')
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("admin.index.users.delete")))])])])])])])])
  }))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'configuration'),
      expression: "activeTab == 'configuration'"
    }],
    staticClass: "panel-body margin-medium-top"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4 panel-content-inner"
  }, [_c('h4', {
    staticClass: "inner-title"
  }, [_vm._v(_vm._s(_vm.$t("admin.configuration.change_video_path")))]), _vm._v(" "), _c('form', {
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-12 form-material video-src"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "video-path"
    }
  }, [_vm._v(_vm._s(_vm.$t("admin.configuration.video_path")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.videoSrc),
      expression: "videoSrc"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "video-path",
      "type": "text",
      "id": "video-path",
      "required": ""
    },
    domProps: {
      "value": (_vm.videoSrc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.videoSrc = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-4 text-center"
  }, [_c('button', {
    staticClass: "btn btn-warning waves-effect waves-classic",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateVideo()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.save")))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-4 ml-4 panel-content-inner"
  }, [_c('h4', {
    staticClass: "inner-title"
  }, [_vm._v(_vm._s(_vm.$t("admin.configuration.add_top_bar_info_title")))]), _vm._v(" "), _c('form', {
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "form-group col-sm-12 form-material video-src"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "topbar-info-text"
    }
  }, [_vm._v(_vm._s(_vm.$t("admin.configuration.add_top_bar_info_text")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.topBarInfoText),
      expression: "topBarInfoText"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "topbar-info-text",
      "type": "text",
      "id": "topbar-info-text"
    },
    domProps: {
      "value": (_vm.topBarInfoText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.topBarInfoText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12 form-material video-src"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t("admin.configuration.add_top_bar_info_enable")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12 form-material video-src"
  }, [_c('switches', {
    attrs: {
      "theme": "bulma",
      "color": "blue",
      "type-bold": "false"
    },
    model: {
      value: (_vm.topBarInfoEnabled),
      callback: function($$v) {
        _vm.topBarInfoEnabled = $$v
      },
      expression: "topBarInfoEnabled"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12 form-material video-src"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t("admin.configuration.add_top_bar_info_color")))])]), _vm._v(" "), _c('div', {
    staticClass: "ml-25"
  }, [_c('color-picker', {
    staticClass: "mb-0",
    attrs: {
      "color": _vm.topBarInfoColor
    },
    model: {
      value: (_vm.topBarInfoColor),
      callback: function($$v) {
        _vm.topBarInfoColor = $$v
      },
      expression: "topBarInfoColor"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-4 text-center"
  }, [_c('button', {
    staticClass: "btn btn-warning waves-effect waves-classic",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateTopBarInfo()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.save")))])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'tools'),
      expression: "activeTab == 'tools'"
    }],
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4 panel-content-inner px-4"
  }, [_c('h4', {
    staticClass: "inner-title"
  }, [_vm._v("Import or update Airbnb reservation")]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "importOrUpdateAirbnbBooking"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.importOrUpdateAirbnbBooking($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.string",
      value: (_vm.importOrUpdateAirbnbBookingConfirmationCode),
      expression: "importOrUpdateAirbnbBookingConfirmationCode",
      modifiers: {
        "string": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Confirmation code"
    },
    domProps: {
      "value": (_vm.importOrUpdateAirbnbBookingConfirmationCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.importOrUpdateAirbnbBookingConfirmationCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.importOrUpdateAirbnbBookingRentalId),
      expression: "importOrUpdateAirbnbBookingRentalId",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control my-4",
    attrs: {
      "type": "text",
      "placeholder": "Rental id"
    },
    domProps: {
      "value": (_vm.importOrUpdateAirbnbBookingRentalId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.importOrUpdateAirbnbBookingRentalId = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-red btn-bold waves-effect waves-classic btn-with-caret"
  }, [_vm._v("Import")])])])])])])])]), _vm._v(" "), _c('VChangeSubscriptionTrial', {
    attrs: {
      "user": _vm.user
    },
    on: {
      "getUsers": _vm.fetch_users
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-062fbb72"}!./src/app/pages/admin/index/index.html
// module id = 1328
// module chunks = 0